import React, { useEffect } from 'react';

import { Box, Button, Divider, Grid, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';

import ProductCard from './ProductCard';

const ProductForm = ({
    allianceId,
    callback,
    initialValues,
    products,
    save,
}) => {
    const { t } = useTranslation();

    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues || { financiers_products: {} },
        mode: 'onChange',
    });

    useEffect(() => reset(initialValues), [initialValues]);

    const handleOnClickSave = (values) =>
        save({ ...values, allianceId: allianceId }, callback);

    return (
        <Stack component="form" onSubmit={handleSubmit(handleOnClickSave)}>
            <Grid container>
                {products.map((product) => (
                    <Grid key={`product-${product.id}`} size={{ lg: 6 }}>
                        <ProductCard
                            control={control}
                            name="financiers_products"
                            product={product}
                        />
                    </Grid>
                ))}
            </Grid>

            <Divider sx={{ mx: (theme) => `${theme.spacing(-2)}!important` }} />

            <Box sx={{ textAlign: 'right' }}>
                <Button type="submit">{t('Update')}</Button>
            </Box>
        </Stack>
    );
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.initialValuesProductForm,
});

const mapDispatchToProps = (dispatch) => ({
    save: (values, callback) =>
        dispatch(actions.saveSelectedProducts(values, callback)),
});

ProductForm.propTypes = {
    allianceId: PropTypes.string,
    callback: PropTypes.func,
    initialValues: PropTypes.object,
    products: PropTypes.array,
    save: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductForm);
